import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          // We handle session recovery from URL explicitly in /auth/callback to avoid noisy
          // client clock skew warnings and to keep the rest of the app URL-clean.
          detectSessionInUrl: false,
        },
      })
    : null;
